import { render, staticRenderFns } from "./AppBackground.vue?vue&type=template&id=68c57c94&scoped=true&"
import script from "./AppBackground.vue?vue&type=script&lang=js&"
export * from "./AppBackground.vue?vue&type=script&lang=js&"
import style0 from "./AppBackground.vue?vue&type=style&index=0&id=68c57c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c57c94",
  null
  
)

export default component.exports